import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const SearchForm = ({
  placeholder,
  searchLabel,
  clearLabel,
  onSearch,
  initialQuery,
  inputLabel
}) => {
  const [q, setQuery] = useState(initialQuery || '');
  const [querySubmitted, setQuerySubmitted] = useState(!!initialQuery);
  const component = useRef(null);
  useEffect(() => {
    if (initialQuery) {
      setQuery(initialQuery);
      setQuerySubmitted(true);
    } else {
      setQuerySubmitted(false);
    }
  }, [initialQuery]);

  useEffect(() => {
    if (q.length === 0) onSearch(q);
  }, [q]);

  const handleTextChange = e => {
    e.preventDefault();
    const { value } = e.target;
    setQuery(value);
    setQuerySubmitted(false);
  };

  const handleInputClear = e => {
    e.preventDefault();
    setQuery('');
  };

  const handleSubmit = e => {
    e.preventDefault();
    onSearch(q);
  };

  const handleInputFocus = e => {
    e.target.placeholder = '';
  };

  const handleInputBlur = e => {
    e.target.placeholder = q.length === 0 ? placeholder : '';
  };

  return (
    <div className="search-bar__bar" aria-owns="options-list" ref={component}>
      <form className="search-bar__form" onSubmit={handleSubmit}>
        <label htmlFor="search-bar">{inputLabel}</label>
        <input
          id="search-bar"
          type="text"
          value={q}
          onChange={handleTextChange}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          className={
            !querySubmitted || !(q.length >= 1)
              ? 'search-bar__input'
              : 'search-bar__input search-bar__input--clear-enabled'
          }
          placeholder={placeholder}
        />
        <input type="submit" hidden />
        <div className="search-bar__actions">
          <button
            className={
              !querySubmitted || !(q.length >= 1)
                ? 'search-bar__clear search-bar__clear--disabled'
                : 'search-bar__clear'
            }
            onClick={handleInputClear}
            aria-label={clearLabel}
          >
            {clearLabel}
          </button>
          <button
            type="submit"
            className={
              q.length >= 1
                ? 'search-bar__submit'
                : 'search-bar__submit search-bar__submit--disabled'
            }
            aria-label={searchLabel}
            disabled={!(q.length >= 1)}
          >
            <svg>
              <use xlinkHref="#search-icon" />
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
};

SearchForm.propTypes = {
  initialQuery: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  searchLabel: PropTypes.string.isRequired,
  clearLabel: PropTypes.string.isRequired,
  onSearch: PropTypes.func,
  inputLabel: PropTypes.string.isRequired
};

export default SearchForm;
